<template>
    <Menubar v-if="isAdmin" class="p-1" :model="ritualMenuItems" />
</template>

<script>
import { mapGetters } from "vuex";
import roleMixins from "@/mixins/roleMixins";
import changeLocalesMixins from "../../mixins/changeLocalesMixins";
import Menubar from 'primevue/menubar'
export default {
    name: "AsRitualMenu",
    components: {
        Menubar,
    },
    computed: {
        ...mapGetters({
            user: "getUser",
            locale: "getLocale",
            languages: "getLanguages",
        }),
    },
    watch: {
        "$i18n.locale"() {
            this.ritualMenuItems = this.getMenuItems()
        },
    },

    data() {
        return {
            ritualMenuItems: this.getMenuItems()
        };
    },
    mixins: [roleMixins],
    methods: {
        getMenuItems() {
            return [
                {
                    label: this.$t("rituals.title"),
                    items: [
                        {
                            label: this.$t("rituals.menu.rituals_management"),
                            command: () => this.$router.push("/ritual/management"),
                        },
                        {
                            label: this.$t("rituals.menu.bloc_management"),
                            command: () => this.$router.push("/ritual/bloc-management"),
                        },
                    ],
                },
            ];
        },
    },
};
</script>

<style lang="scss"></style>
